function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { decode as base64url } from '../../runtime/base64url.js';
import decrypt from '../../runtime/decrypt.js';
import { JOSEAlgNotAllowed, JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import isDisjoint from '../../lib/is_disjoint.js';
import isObject from '../../lib/is_object.js';
import decryptKeyManagement from '../../lib/decrypt_key_management.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import generateCek from '../../lib/cek.js';
import validateCrit from '../../lib/validate_crit.js';
import validateAlgorithms from '../../lib/validate_algorithms.js';
export function flattenedDecrypt(_x, _x2, _x3) {
  return _flattenedDecrypt.apply(this, arguments);
}
function _flattenedDecrypt() {
  _flattenedDecrypt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(jwe, key, options) {
    var _jwe$protected;
    var parsedProt, _protectedHeader, joseHeader, alg, enc, keyManagementAlgorithms, contentEncryptionAlgorithms, encryptedKey, resolvedKey, cek, iv, tag, protectedHeader, additionalData, ciphertext, plaintext, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (isObject(jwe)) {
            _context.next = 2;
            break;
          }
          throw new JWEInvalid('Flattened JWE must be an object');
        case 2:
          if (!(jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined)) {
            _context.next = 4;
            break;
          }
          throw new JWEInvalid('JOSE Header missing');
        case 4:
          if (!(jwe.iv !== undefined && typeof jwe.iv !== 'string')) {
            _context.next = 6;
            break;
          }
          throw new JWEInvalid('JWE Initialization Vector incorrect type');
        case 6:
          if (!(typeof jwe.ciphertext !== 'string')) {
            _context.next = 8;
            break;
          }
          throw new JWEInvalid('JWE Ciphertext missing or incorrect type');
        case 8:
          if (!(jwe.tag !== undefined && typeof jwe.tag !== 'string')) {
            _context.next = 10;
            break;
          }
          throw new JWEInvalid('JWE Authentication Tag incorrect type');
        case 10:
          if (!(jwe.protected !== undefined && typeof jwe.protected !== 'string')) {
            _context.next = 12;
            break;
          }
          throw new JWEInvalid('JWE Protected Header incorrect type');
        case 12:
          if (!(jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== 'string')) {
            _context.next = 14;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key incorrect type');
        case 14:
          if (!(jwe.aad !== undefined && typeof jwe.aad !== 'string')) {
            _context.next = 16;
            break;
          }
          throw new JWEInvalid('JWE AAD incorrect type');
        case 16:
          if (!(jwe.header !== undefined && !isObject(jwe.header))) {
            _context.next = 18;
            break;
          }
          throw new JWEInvalid('JWE Shared Unprotected Header incorrect type');
        case 18:
          if (!(jwe.unprotected !== undefined && !isObject(jwe.unprotected))) {
            _context.next = 20;
            break;
          }
          throw new JWEInvalid('JWE Per-Recipient Unprotected Header incorrect type');
        case 20:
          if (!jwe.protected) {
            _context.next = 29;
            break;
          }
          _context.prev = 21;
          _protectedHeader = base64url(jwe.protected);
          parsedProt = JSON.parse(decoder.decode(_protectedHeader));
          _context.next = 29;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](21);
          throw new JWEInvalid('JWE Protected Header is invalid');
        case 29:
          if (isDisjoint(parsedProt, jwe.header, jwe.unprotected)) {
            _context.next = 31;
            break;
          }
          throw new JWEInvalid('JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint');
        case 31:
          joseHeader = _objectSpread(_objectSpread(_objectSpread({}, parsedProt), jwe.header), jwe.unprotected);
          validateCrit(JWEInvalid, new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
          if (!(joseHeader.zip !== undefined)) {
            _context.next = 35;
            break;
          }
          throw new JOSENotSupported('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        case 35:
          alg = joseHeader.alg, enc = joseHeader.enc;
          if (!(typeof alg !== 'string' || !alg)) {
            _context.next = 38;
            break;
          }
          throw new JWEInvalid('missing JWE Algorithm (alg) in JWE Header');
        case 38:
          if (!(typeof enc !== 'string' || !enc)) {
            _context.next = 40;
            break;
          }
          throw new JWEInvalid('missing JWE Encryption Algorithm (enc) in JWE Header');
        case 40:
          keyManagementAlgorithms = options && validateAlgorithms('keyManagementAlgorithms', options.keyManagementAlgorithms);
          contentEncryptionAlgorithms = options && validateAlgorithms('contentEncryptionAlgorithms', options.contentEncryptionAlgorithms);
          if (!(keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith('PBES2'))) {
            _context.next = 44;
            break;
          }
          throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter value not allowed');
        case 44:
          if (!(contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc))) {
            _context.next = 46;
            break;
          }
          throw new JOSEAlgNotAllowed('"enc" (Encryption Algorithm) Header Parameter value not allowed');
        case 46:
          if (!(jwe.encrypted_key !== undefined)) {
            _context.next = 54;
            break;
          }
          _context.prev = 47;
          encryptedKey = base64url(jwe.encrypted_key);
          _context.next = 54;
          break;
        case 51:
          _context.prev = 51;
          _context.t1 = _context["catch"](47);
          throw new JWEInvalid('Failed to base64url decode the encrypted_key');
        case 54:
          resolvedKey = false;
          if (!(typeof key === 'function')) {
            _context.next = 60;
            break;
          }
          _context.next = 58;
          return key(parsedProt, jwe);
        case 58:
          key = _context.sent;
          resolvedKey = true;
        case 60:
          _context.prev = 60;
          _context.next = 63;
          return decryptKeyManagement(alg, key, encryptedKey, joseHeader, options);
        case 63:
          cek = _context.sent;
          _context.next = 71;
          break;
        case 66:
          _context.prev = 66;
          _context.t2 = _context["catch"](60);
          if (!(_context.t2 instanceof TypeError || _context.t2 instanceof JWEInvalid || _context.t2 instanceof JOSENotSupported)) {
            _context.next = 70;
            break;
          }
          throw _context.t2;
        case 70:
          cek = generateCek(enc);
        case 71:
          if (!(jwe.iv !== undefined)) {
            _context.next = 79;
            break;
          }
          _context.prev = 72;
          iv = base64url(jwe.iv);
          _context.next = 79;
          break;
        case 76:
          _context.prev = 76;
          _context.t3 = _context["catch"](72);
          throw new JWEInvalid('Failed to base64url decode the iv');
        case 79:
          if (!(jwe.tag !== undefined)) {
            _context.next = 87;
            break;
          }
          _context.prev = 80;
          tag = base64url(jwe.tag);
          _context.next = 87;
          break;
        case 84:
          _context.prev = 84;
          _context.t4 = _context["catch"](80);
          throw new JWEInvalid('Failed to base64url decode the tag');
        case 87:
          protectedHeader = encoder.encode((_jwe$protected = jwe.protected) !== null && _jwe$protected !== void 0 ? _jwe$protected : '');
          if (jwe.aad !== undefined) {
            additionalData = concat(protectedHeader, encoder.encode('.'), encoder.encode(jwe.aad));
          } else {
            additionalData = protectedHeader;
          }
          _context.prev = 89;
          ciphertext = base64url(jwe.ciphertext);
          _context.next = 96;
          break;
        case 93:
          _context.prev = 93;
          _context.t5 = _context["catch"](89);
          throw new JWEInvalid('Failed to base64url decode the ciphertext');
        case 96:
          _context.next = 98;
          return decrypt(enc, cek, ciphertext, iv, tag, additionalData);
        case 98:
          plaintext = _context.sent;
          result = {
            plaintext: plaintext
          };
          if (jwe.protected !== undefined) {
            result.protectedHeader = parsedProt;
          }
          if (!(jwe.aad !== undefined)) {
            _context.next = 109;
            break;
          }
          _context.prev = 102;
          result.additionalAuthenticatedData = base64url(jwe.aad);
          _context.next = 109;
          break;
        case 106:
          _context.prev = 106;
          _context.t6 = _context["catch"](102);
          throw new JWEInvalid('Failed to base64url decode the aad');
        case 109:
          if (jwe.unprotected !== undefined) {
            result.sharedUnprotectedHeader = jwe.unprotected;
          }
          if (jwe.header !== undefined) {
            result.unprotectedHeader = jwe.header;
          }
          if (!resolvedKey) {
            _context.next = 113;
            break;
          }
          return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
            key: key
          }));
        case 113:
          return _context.abrupt("return", result);
        case 114:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[21, 26], [47, 51], [60, 66], [72, 76], [80, 84], [89, 93], [102, 106]]);
  }));
  return _flattenedDecrypt.apply(this, arguments);
}